import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const BetName = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    lineHeight: '20px',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const IconMulti = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '16px',
    width: '16px',
    marginLeft: defaultTheme.spacing.xs,
    '&:before': {
      content: `''`,
      position: 'absolute',
      height: '100%',
      width: '100%',
      border: `1px solid ${defaultTheme.border.color.black}`,
      borderRadius: '2px',
    },
  }),
);
